import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from 'Core/utils/numberFormat';
import { TextButton } from 'Core/components/Button';

export default function AmountBar({ payment, title, onChangeMethod }) {
  const { t } = useTranslation();
  return (
    <div
      className="flex flex-wrap items-center justify-between gap-2 bg-primary text-white rounded-md px-4 py-2.5 mb-3"
      data-testid="checkout-amount-bar"
    >
      <span className="font-semibold">{title}</span>
      <span className="flex items-center gap-4">
        {onChangeMethod && (
          <TextButton
            className="!text-white text-sm underline cursor-pointer rounded-md !px-3 !py-1 border border-white/40 hover:!bg-white/20 hover:!text-white hover:border-white transition-colors"
            onClick={onChangeMethod}
            data-testid="change-method"
          >
            {t('checkout.changePaymentMethod', 'Zahlungsart ändern')}
          </TextButton>
        )}
        <span className="font-bold" data-testid="checkout-amount">
          {formatCurrency(payment.amount_to_pay, { currency: payment.currency })}
        </span>
      </span>
    </div>
  );
}
